import { Action } from '@ngrx/store';
import { StorageType } from '../../services/storage/storage.service';

export class StorageAction implements Action {

    public static storeItem: string = '[Storage] store_item';
    public static unstoreItem: string = '[Storage] unstore_item';

    public static setLocalItem: string = '[Storage] set_local_item';
    public static removeLocalItem: string = '[Storage] remove_local_item';

    public static setCookieItem: string = '[Storage] set_cookie_item';
    public static removeCookieItem: string = '[Storage] remove_cookie_item';

    public static setSessionItem: string = '[Storage] set_session_item';
    public static removeSessionItem: string = '[Storage] remove_session_item';

    constructor(
        public type: string,
        public payload?: {
            storageType?: StorageType
            key: string;
            data?: string;
            expiresIn?: Date,
            domain: string,
            path?: string
        },
    ) {}
}
